import { render, staticRenderFns } from "./lottery_win_record.vue?vue&type=template&id=483d2db6"
import script from "./lottery_win_record.vue?vue&type=script&lang=js"
export * from "./lottery_win_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports